import { HttpResponse } from '@angular/common/http';
import { Component, inject, OnDestroy, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { interval, timer } from 'rxjs';
import { DtcRetrievalService, J1939DtcBase, t_Dtc, ECU} from 'src/app/services/apiHandler/dtc-retrieval/dtc-retrieval.service';
import { InfoDialogComponent } from './InfoDialog/info-dialog/info-dialog.component';
import { IconHelper } from 'src/app/services/helper/icon-helper';
import { DidConfigService } from 'src/app/services/apiHandler/did-config/did-config.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/services/helper/global-helper';
import { RoleService } from 'src/app/services/helper/role-handling-helper';
import { MatSnackBar } from '@angular/material/snack-bar';


const SPNJSON: String = "J1939.SRC.";
const CODEWAIT: number = 202;
const CODEOK: number = 200;

@Component({
  selector: 'app-dtc',
  templateUrl: './dtc.component.html',
  styleUrls: ['./dtc.component.scss']
})

export class DtcComponent implements OnDestroy{
  displayedColumns: string[] = [];//['ecu','criticality', 'message', 'spn', 'fmi', 'timestamp', 'click'];/*, 'troubleshoot'];*/
  public clicked: boolean = false;
  public noDTCs: boolean = false;
  private subfunctionType = 2;
  public statusMask?: number = 9;
  public errorMessage: string = "";
  public disableSelect: boolean = false;
  public subscription: any | undefined;
  // damit überprüfen ob es einen gibt und je nachdem disable schalten
  public disableTrouble: boolean = true;
  private machineType: string = '';
  private machineSeries: string = '';
  private line: string = '';
  private status: any;
  //Periodic fetching
  periodicStatus: string = "";
  toggle = true;
  color = "primary";
  periodicTooltip = "Start";
  periodicStarted: boolean = false;
  period: any | undefined;
  loadRequest: boolean = false;

  private snackbar = inject(MatSnackBar);

  public ecus = this.global.dtcEcus;
  /*public ecus: ECU[] = [
    {value: 120, viewValue: "Master (120)", notAnOption: false},
    {value: 0, viewValue: "Engine (0)", notAnOption: false},
    {value: 121, viewValue: "Slave (121)", notAnOption: false},
    {value: 122, viewValue: "Kabinensteuergerät (122)", notAnOption: false},
    //{value: 188, viewValue: "Telemetriemodul (188)", notAnOption: true},
  ];*/

  public options = [
    {id: 9, viewValue: "DTC.OPTION_ACTIVE"},
    {id: 8, viewValue: "DTC.OPTION_MEMORY"},
  ];

  ecu = this.ecus[0].value;

  public fmiMapping: any;
  public spnMapping: any;
  public spnDetailMapping: any;
  public noDetailMapping: boolean = false;

  public tableSet: MatTableDataSource<t_Dtc> = new MatTableDataSource<t_Dtc>();
  @ViewChild(MatTable) table: MatTable<any> | undefined;

  constructor(private dtcRetrievalService: DtcRetrievalService, public dialog: MatDialog, public iconHelper: IconHelper, public didConfigService: DidConfigService, private translate: TranslateService, private global: GlobalService, public roleService: RoleService) {
    this.global.machineInfos.subscribe({
      next: newValue => {this.line = newValue.line;}
    });
    this.dtcRetrievalService.getMappingFiles('fmi', 120, this.line, 'en').subscribe({ 
      next: (resp) => {
        this.fmiMapping = JSON.parse(JSON.stringify(resp.body));
      },
      error: (error) => {
        console.log(error.error);
        this.cancelRequest();
        this.translate.stream("MESSAGES.NO_FILES_LOADED").subscribe((res) => { this.errorMessage = res;});
      }
    });
    this.translate.stream("DTC.BTN_ZYK_PERIOD").subscribe((res) => { this.periodicStatus = res;});

    this.global.io.subscribe({
      next: newValue => {this.ecu = newValue.dtc_ecu;}
    });   
    this.global.machineNumber.subscribe({
      next: newValue => {
        this.machineSeries = newValue.series;
        this.machineType = newValue.number.split('.')[0];
      }
    });
    this.columnsToDisplay();  
  }

  ngOnDestroy(){
    this.snackbar?.dismiss();
    this.period?.unsubscribe();
    this.subscription?.unsubscribe();
    this.global.io.next({dtc_ecu: 120});
  }

  public getFmiTooltip(fmi: string){
    return this.fmiMapping[Number(fmi.substring(0,fmi.indexOf(' ')))]['message'];
  }

  private getMappingFile(type: string, ecuId: number): Promise<void> {
    return new Promise((resolve) => {
      this.dtcRetrievalService.getMappingFiles(type, ecuId, this.line, 'en').subscribe({
        next: (resp) => {
          let file = JSON.parse(JSON.stringify(resp.body));
          resolve(file);
        }, 
        error: (error) => {
          console.log(error.error);
          resolve();
          //this.cancelRequest();
          //this.translate.stream("MESSAGES.NO_FILES_LOADED").subscribe((res) => { this.errorMessage = res;});
        }
      });
    });
  }

  private combineData (rawData: J1939DtcBase[]) {
    this.tableSet.data = [];
    rawData.forEach((datapoint) => {
      // get data already there
      let spn: number | undefined = datapoint.spn;
      let id: number | undefined = datapoint.ecuId;
      let timestamp: number | undefined = datapoint.timestamp;
      if(datapoint.fmi != null){
        var text = this.fmiMapping[datapoint.fmi]['message'];
        var fmi: string | undefined = datapoint.fmi?.toString() + " - " + text;
      } else {
        fmi = "-";
      }
      // map spn with message
      if(spn != undefined && id != undefined){
        let path:any;
        path = this.spnDetailMapping?.data[SPNJSON + id!.toString() + '.SPN.' + spn + '.FMI.' + datapoint.fmi];
        if (path != undefined) {
              var criticality = path.lamp;
            } else {
              criticality = 4;
            }
        if(this.spnMapping != undefined) {
          var message = this.spnMapping[SPNJSON + id!.toString() + '.SPN.' + datapoint.spn];
        }
        if(message == undefined){
          message = this.translate.instant("MESSAGES.UNKNOWN_SPN");
        }  
      }
      // Troubleshooter vorerst auskommentiert bis stabiler
      /*this.getTroubleshooter(id!.toString(), spn!.toString(), fmi.split(' ')[0]).then(ans => {
        this.status = ans.status;
        let index = this.tableSet.data.findIndex(set => 
          set.ecuId === id && set.spn === spn && set.fmi === fmi
        );
        this.tableSet.data[index].troubleshoot = this.status;
        this.tableSet.data[index].troubleshootPath = ans.res;
        this.table?.renderRows();
      });*/

      // new table entry
      var point: t_Dtc = {
        ecuId: id,
        spn: spn,
        fmi: fmi,
        timestamp: timestamp,
        message: message,
        criticality: criticality,
        occurence: 0,
        activity: ""//,
        //troubleshoot: this.status
      };
      this.tableSet.data.push(point); 
    });
    // sorts array so newest error (so operatin hour of ecu is biggest)
    this.tableSet.data = this.tableSet.data.sort((a,b) => b.timestamp! - a.timestamp!);
    this.table?.renderRows();
  }

  async getTroubleshooter(id: string, spn: string, fmi: string) {
    let ans = await this.dtcRetrievalService.checkTroubleshooterAvailable(this.machineType, id!.toString(), spn!.toString(), fmi.split(' ')[0], this.machineSeries).then((value) => {
      return value;
    });
    return ans;    
  }


  public getDTCs() {
    if(this.ecu != undefined){
      this.disableSelect = true;
      this.tableSet.data = [];
      this.clicked = true;
      this.noDTCs = false;

      if(this.statusMask == 8 && (this.ecu == 120 || this.ecu == 121 || this.ecu == 122)) {
        let subfunctiontype = 22;
        let recordNumber = 1;
        this.subscription = this.dtcRetrievalService.getDtcsWithTimestamp(this.ecu,subfunctiontype,recordNumber,true).subscribe({
          next: (obs) => {
            // DTC are already sent back - fill table accordingly
            if(obs.status == CODEOK) {
              // get data from obs.body and fill table
              this.getDataAndFillTable(obs); 
            }
            // DTC are not already back - next request listen to dtc
            if(obs.status == CODEWAIT){
              // send new request for data
              let timer = interval(2000).subscribe(() => {
                this.subscription = this.dtcRetrievalService.getDtcsWithTimestampAfterLoading(this.ecu,subfunctiontype,recordNumber).subscribe((data) => {
                  if(data.status == CODEOK) {
                    this.getDataAndFillTable(data);
                    timer.unsubscribe();
                  }
                });
              });
              // timer to cancel requests after 15s
              setTimeout(() => {
                if(!timer.closed){
                  timer.unsubscribe();
                  this.cancelRequest();
                  this.translate.stream("MESSAGES.CHECK_ECU").subscribe((res) => { this.errorMessage = res;});
                }
              }, 15000);
            }
          },
          error: (error) => {
            console.log(error.error);
            this.cancelRequest();
            this.translate.stream("MESSAGES.CHECK_ECU").subscribe((res) => { this.errorMessage = res;});
          }
        });
      } else {
        this.subscription = this.dtcRetrievalService.getDtcsByStatusMask(this.ecu,this.subfunctionType,this.statusMask!,true).subscribe({
          next: (obs) => {
            // DTC are already sent back - fill table accordingly
            if(obs.status == CODEOK) {
              // get data from obs.body and fill table
              this.getDataAndFillTable(obs); 
            }
            // DTC are not already back - next request listen to dtc
            if(obs.status == CODEWAIT){
              // send new request for data
              let timer = interval(2000).subscribe(() => {
                this.subscription = this.dtcRetrievalService.getDtcsAfterLoading(this.ecu,this.subfunctionType,this.statusMask!).subscribe((data) => {
                  if(data.status == CODEOK) {
                    this.getDataAndFillTable(data);
                    timer.unsubscribe();
                  }
                });
              });
              // timer to cancel requests after 15s
              setTimeout(() => {
                if(!timer.closed){
                  timer.unsubscribe();
                  this.cancelRequest();
                  this.translate.stream("MESSAGES.CHECK_ECU").subscribe((res) => { this.errorMessage = res;});
                }
              }, 15000);
            }
          },
          error: (error) => {
            console.log(error.error);
            this.cancelRequest();
            this.translate.stream("MESSAGES.CHECK_ECU").subscribe((res) => { this.errorMessage = res;});
          }
        });
      }
  
    } else {
      this.tableSet.data = [];
      this.noDTCs = true;
      this.clicked = false;
      this.translate.stream("MESSAGES.NO_ECU").subscribe((res) => { this.errorMessage = res;});
    }
  }


  private getDataAndFillTable(data: HttpResponse<J1939DtcBase[]>){
    if(data.body && data.body.length > 0){
      this.getMappingFile('dtc', this.ecu).then((detail) => {
        if(detail != undefined) {
          this.spnDetailMapping = JSON.parse(JSON.stringify(detail));
        } else {
          this.noDetailMapping = true;
          this.displayedColumns = this.displayedColumns.filter(item => item !== 'click');
        }
        this.getMappingFile('spn', this.ecu).then((spn) => {
          this.spnMapping = JSON.parse(JSON.stringify(spn));
          this.combineData(data.body!);
        });        
      });      
    } else {
      this.noDTCs = true;
      this.tableSet.data = [];
      this.translate.stream("MESSAGES.NO_DTCS").subscribe((res) => { this.errorMessage = res;});
    }
    this.disableSelect = false;
    this.clicked = false;
    this.loadRequest = false;
  }


  public deleteDTCs() {
    this.errorMessage = "";
    this.clicked = false;
    this.noDTCs = false;
    this.tableSet.data = []; 
    let did_id: number;
    if(this.ecu == 120){
      did_id = 346;
    } else if( this.ecu == 121) {
      did_id = 347;
    } else if(this.ecu == 122) {
      did_id = 348;
    } else {
      did_id = 0;
      return;
    }
    this.didConfigService.writeDataByID(this.ecu, did_id, 1).subscribe(); 
  }

  public cancelRequest() {
    this.subscription.unsubscribe();
    this.errorMessage = this.translate.instant("MESSAGES.REQUEST_CANCEL");;
    this.noDTCs = true;
    this.clicked = false;
    this.disableSelect = false;
    this.loadRequest = false;
    if(!this.toggle) {
      this.repeatRequest();
    }
  }

  public repeatRequest() {
    this.clicked = !this.clicked;
    this.toggle = !this.toggle;
    this.periodicStatus = this.toggle ? this.translate.instant("DTC.BTN_ZYK_PERIOD") : this.translate.instant("DTC.BTN_ZYK_STOP")
    this.color = this.toggle ? 'primary' : 'warn';
    this.periodicTooltip = this.toggle ? 'Start' : 'Stop'
    
    // start periodic requests
    if(!this.toggle){
      this.periodicStarted = true;
      this.clicked = true;
      this.noDTCs = false;
      this.period = timer(0,10000).subscribe(() => {
        this.subscription?.unsubscribe();
        this.loadRequest = true;
        this.request();
      });
    }
    // stop periodic requests
    if(this.toggle){
      this.periodicStarted = false;
      this.subscription.unsubscribe();
      this.clicked = false;
      this.period.unsubscribe();
      this.loadRequest = false;
    }    
  }

  private request(){
    this.subscription = this.dtcRetrievalService.getDtcsByStatusMask(this.ecu,this.subfunctionType,this.statusMask!,true).subscribe({
      next: (obs) => {
        // DTC are already sent back - fill table accordingly
        if(obs.status == CODEOK) {
          // get data from obs.body and fill table
          this.getDataAndFillTable(obs); 
        }
        // DTC are not already back - next request listen to dtc
        if(obs.status == CODEWAIT){
          // send new request for data        
          let timer = interval(2000).subscribe(() => {
            this.subscription = this.dtcRetrievalService.getDtcsAfterLoading(this.ecu,this.subfunctionType,this.statusMask!).subscribe((data) => {
              if(data.status == CODEOK) {
                timer.unsubscribe();
                this.getDataAndFillTable(data);
              }
            });
          });
          // timer to cancel requests after 15s
          setTimeout(() => {
            if(!timer.closed){
              timer.unsubscribe();
              this.cancelRequest();
              this.errorMessage = this.translate.instant("MESSAGES.CHECK_ECU");
            }
          }, 15000);
        }
      },
      error: (error) => {
        console.log(error.error);
        this.cancelRequest();
        this.errorMessage = this.translate.instant("MESSAGES.CHECK_ECU");
        this.repeatRequest();
      }
    });
  }

  public clearList() {
    this.tableSet.data = [];
    this.noDTCs = false;
    this.columnsToDisplay();
  }

  public showInfo(row: t_Dtc){
    if(!this.noDetailMapping) {
      this.dialog.open(InfoDialogComponent, {
        data: row,
      });
    } else {
      console.log('noDetailInfos');
    }
  }

  private columnsToDisplay() {
    //Active
    if(this.statusMask == 9) {
      this. displayedColumns = ['ecu','criticality', 'message', 'spn', 'fmi', 'click'];/*, 'troubleshoot'];*/
    } else if(this.statusMask == 8) { // Memory
      this. displayedColumns = ['ecu','criticality', 'message', 'spn', 'fmi', 'timestamp', 'click'];/*, 'troubleshoot'];*/
    }
  }

  public linkToTroubleshoot(element: any) {
    //console.log("link to troubleshoot", element);
    let url = element.troubleshootPath.article
    window.open(url);
  }

  public showTip() {
    this.snackbar.open(this.translate.instant('DTC.TOOLTIP.TIME_EXPL'), 'OK', { horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'info-snackbar', duration: 15000});
  }
}
